const en = {
    idle: 'Idle',
    idleDetail: 'Idle **{{amount}}** · **{{minutes}} min** at **{{rate}}/min** after **{{grace}} min** grace',
    idleUnknown: 'Idle **{{amount}}**. Billed minutes or pinned policy not recorded.',
    idleIncluded: 'incl. **{{amount}}** idle',
    historical: 'Earned in {{currency}} before the switch to {{current}}: **{{amount}}**',
    otherCurrency: 'Earned in {{currency}}: **{{amount}}**',
    noEarnings: 'No {{currency}} earnings in this period',
    unavailable: 'Currency or amount not recorded',
    sentAs: 'sent as **{{amount}}**',
};
export const HOST_DISPLAY_LOCALES = [
    'en',
    'es',
    'fr',
    'hy',
    'it',
    'ja',
    'ko',
    'pt',
    'ru',
    'uk',
    'zh',
];
const copy = {
    en,
    es: {
        idle: 'Inactividad',
        idleDetail: 'Inactividad **{{amount}}** · **{{minutes}} min** a **{{rate}}/min** tras **{{grace}} min** de cortesía',
        idleUnknown: 'Inactividad **{{amount}}**. No se registraron los minutos facturados o la política fijada.',
        idleIncluded: 'incl. **{{amount}}** de inactividad',
        historical: 'Ganado en {{currency}} antes del cambio a {{current}}: **{{amount}}**',
        otherCurrency: 'Ganado en {{currency}}: **{{amount}}**',
        noEarnings: 'Sin ingresos en {{currency}} en este período',
        unavailable: 'Moneda o importe no registrado',
        sentAs: 'enviado como **{{amount}}**',
    },
    fr: {
        idle: 'Inactivité',
        idleDetail: 'Inactivité **{{amount}}** · **{{minutes}} min** à **{{rate}}/min** après **{{grace}} min** de grâce',
        idleUnknown: 'Inactivité **{{amount}}**. Minutes facturées ou conditions fixées non enregistrées.',
        idleIncluded: 'dont **{{amount}}** d’inactivité',
        historical: 'Gagné en {{currency}} avant le passage en {{current}} : **{{amount}}**',
        otherCurrency: 'Gagné en {{currency}} : **{{amount}}**',
        noEarnings: 'Aucun revenu en {{currency}} sur cette période',
        unavailable: 'Devise ou montant non enregistré',
        sentAs: 'envoyé sous forme de **{{amount}}**',
    },
    hy: {
        idle: 'Պարապուրդ',
        idleDetail: 'Պարապուրդ՝ **{{amount}}** · **{{minutes}} րոպե**, **{{rate}}/րոպե** սակագնով, **{{grace}} րոպե** արտոնյալ ժամանակից հետո',
        idleUnknown: 'Պարապուրդ՝ **{{amount}}**։ Վճարված րոպեները կամ ամրագրված պայմանները գրանցված չեն։',
        idleIncluded: 'ներառյալ **{{amount}}** պարապուրդի վճար',
        historical: 'Վաստակած {{currency}}-ով՝ մինչև {{current}}-ի անցնելը․ **{{amount}}**',
        otherCurrency: 'Վաստակած {{currency}}-ով․ **{{amount}}**',
        noEarnings: 'Այս ժամանակահատվածում {{currency}}-ով եկամուտ չկա',
        unavailable: 'Արժույթը կամ գումարը գրանցված չէ',
        sentAs: 'ուղարկվել է որպես **{{amount}}**',
    },
    it: {
        idle: 'Sosta',
        idleDetail: 'Sosta **{{amount}}** · **{{minutes}} min** a **{{rate}}/min** dopo **{{grace}} min** di tolleranza',
        idleUnknown: 'Sosta **{{amount}}**. Minuti fatturati o condizioni fissate non registrati.',
        idleIncluded: 'incl. **{{amount}}** di sosta',
        historical: 'Guadagnato in {{currency}} prima del passaggio a {{current}}: **{{amount}}**',
        otherCurrency: 'Guadagnato in {{currency}}: **{{amount}}**',
        noEarnings: 'Nessun guadagno in {{currency}} in questo periodo',
        unavailable: 'Valuta o importo non registrato',
        sentAs: 'inviato come **{{amount}}**',
    },
    ja: {
        idle: 'アイドル料金',
        idleDetail: 'アイドル料金 **{{amount}}** · **{{grace}}分**の猶予後、**{{rate}}/分**で**{{minutes}}分**',
        idleUnknown: 'アイドル料金 **{{amount}}**。請求対象の分数または開始時の料金条件が記録されていません。',
        idleIncluded: 'アイドル料金 **{{amount}}** を含む',
        historical: '{{current}}への切り替え前の{{currency}}収益：**{{amount}}**',
        otherCurrency: '{{currency}}の収益：**{{amount}}**',
        noEarnings: 'この期間の{{currency}}収益はありません',
        unavailable: '通貨または金額が記録されていません',
        sentAs: '**{{amount}}** として送金',
    },
    ko: {
        idle: '유휴 요금',
        idleDetail: '유휴 요금 **{{amount}}** · **{{grace}}분** 유예 후 **{{rate}}/분**으로 **{{minutes}}분**',
        idleUnknown: '유휴 요금 **{{amount}}**. 청구된 분 또는 시작 시 요금 정책이 기록되지 않았습니다.',
        idleIncluded: '유휴 요금 **{{amount}}** 포함',
        historical: '{{current}} 전환 전 {{currency}} 수익: **{{amount}}**',
        otherCurrency: '{{currency}} 수익: **{{amount}}**',
        noEarnings: '이 기간에 {{currency}} 수익이 없습니다',
        unavailable: '통화 또는 금액이 기록되지 않았습니다',
        sentAs: '**{{amount}}**로 송금됨',
    },
    pt: {
        idle: 'Inatividade',
        idleDetail: 'Inatividade **{{amount}}** · **{{minutes}} min** a **{{rate}}/min** após **{{grace}} min** de tolerância',
        idleUnknown: 'Inatividade **{{amount}}**. Minutos cobrados ou regras fixadas não registrados.',
        idleIncluded: 'incl. **{{amount}}** de inatividade',
        historical: 'Ganho em {{currency}} antes da mudança para {{current}}: **{{amount}}**',
        otherCurrency: 'Ganho em {{currency}}: **{{amount}}**',
        noEarnings: 'Sem ganhos em {{currency}} neste período',
        unavailable: 'Moeda ou valor não registrado',
        sentAs: 'enviado como **{{amount}}**',
    },
    ru: {
        idle: 'Простой',
        idleDetail: 'Простой **{{amount}}** · **{{minutes}} мин** по **{{rate}}/мин** после **{{grace}} мин** льготного времени',
        idleUnknown: 'Простой **{{amount}}**. Оплачиваемые минуты или условия на начало сеанса не записаны.',
        idleIncluded: 'вкл. **{{amount}}** за простой',
        historical: 'Заработано в {{currency}} до перехода на {{current}}: **{{amount}}**',
        otherCurrency: 'Заработано в {{currency}}: **{{amount}}**',
        noEarnings: 'Нет дохода в {{currency}} за этот период',
        unavailable: 'Валюта или сумма не записана',
        sentAs: 'отправлено как **{{amount}}**',
    },
    uk: {
        idle: 'Простій',
        idleDetail: 'Простій **{{amount}}** · **{{minutes}} хв** за **{{rate}}/хв** після **{{grace}} хв** пільгового часу',
        idleUnknown: 'Простій **{{amount}}**. Оплачувані хвилини або умови на початок сеансу не записані.',
        idleIncluded: 'вкл. **{{amount}}** за простій',
        historical: 'Зароблено в {{currency}} до переходу на {{current}}: **{{amount}}**',
        otherCurrency: 'Зароблено в {{currency}}: **{{amount}}**',
        noEarnings: 'Немає доходу в {{currency}} за цей період',
        unavailable: 'Валюту або суму не записано',
        sentAs: 'надіслано як **{{amount}}**',
    },
    zh: {
        idle: '占位费',
        idleDetail: '占位费 **{{amount}}** · **{{grace}}分钟**宽限后，以**{{rate}}/分钟**计费**{{minutes}}分钟**',
        idleUnknown: '占位费 **{{amount}}**。计费分钟数或开始时的费率规则未记录。',
        idleIncluded: '含 **{{amount}}** 占位费',
        historical: '切换为{{current}}前的{{currency}}收益：**{{amount}}**',
        otherCurrency: '{{currency}}收益：**{{amount}}**',
        noEarnings: '本期间没有{{currency}}收益',
        unavailable: '币种或金额未记录',
        sentAs: '已以 **{{amount}}** 汇出',
    },
};
export function hostDisplayLocale(locale) {
    const code = locale?.toLowerCase().split(/[-_]/)[0];
    return HOST_DISPLAY_LOCALES.includes(code)
        ? code
        : 'en';
}
const recordedCopy = {
    en: {
        historical: 'Recorded in {{currency}} before the switch to {{current}}: **{{amount}}**',
        otherCurrency: 'Recorded in {{currency}}: **{{amount}}**',
        noEarnings: 'No {{currency}} amount in this period',
    },
    es: {
        historical: 'Registrado en {{currency}} antes del cambio a {{current}}: **{{amount}}**',
        otherCurrency: 'Registrado en {{currency}}: **{{amount}}**',
        noEarnings: 'Sin importe en {{currency}} en este período',
    },
    fr: {
        historical: 'Enregistré en {{currency}} avant le passage en {{current}} : **{{amount}}**',
        otherCurrency: 'Enregistré en {{currency}} : **{{amount}}**',
        noEarnings: 'Aucun montant en {{currency}} sur cette période',
    },
    hy: {
        historical: 'Գրանցված {{currency}}-ով՝ մինչև {{current}}-ի անցնելը․ **{{amount}}**',
        otherCurrency: 'Գրանցված {{currency}}-ով․ **{{amount}}**',
        noEarnings: 'Այս ժամանակահատվածում {{currency}}-ով գումար չկա',
    },
    it: {
        historical: 'Registrato in {{currency}} prima del passaggio a {{current}}: **{{amount}}**',
        otherCurrency: 'Registrato in {{currency}}: **{{amount}}**',
        noEarnings: 'Nessun importo in {{currency}} in questo periodo',
    },
    ja: {
        historical: '{{current}}への切り替え前に記録された{{currency}}の金額：**{{amount}}**',
        otherCurrency: '{{currency}}の記録額：**{{amount}}**',
        noEarnings: 'この期間の{{currency}}金額はありません',
    },
    ko: {
        historical: '{{current}} 전환 전 {{currency}} 기록 금액: **{{amount}}**',
        otherCurrency: '{{currency}} 기록 금액: **{{amount}}**',
        noEarnings: '이 기간에 {{currency}} 금액이 없습니다',
    },
    pt: {
        historical: 'Registrado em {{currency}} antes da mudança para {{current}}: **{{amount}}**',
        otherCurrency: 'Registrado em {{currency}}: **{{amount}}**',
        noEarnings: 'Sem valor em {{currency}} neste período',
    },
    ru: {
        historical: 'Учтено в {{currency}} до перехода на {{current}}: **{{amount}}**',
        otherCurrency: 'Учтено в {{currency}}: **{{amount}}**',
        noEarnings: 'Нет суммы в {{currency}} за этот период',
    },
    uk: {
        historical: 'Обліковано в {{currency}} до переходу на {{current}}: **{{amount}}**',
        otherCurrency: 'Обліковано в {{currency}}: **{{amount}}**',
        noEarnings: 'Немає суми в {{currency}} за цей період',
    },
    zh: {
        historical: '切换为{{current}}前记录的{{currency}}金额：**{{amount}}**',
        otherCurrency: '{{currency}}记录金额：**{{amount}}**',
        noEarnings: '本期间没有{{currency}}金额',
    },
};
export function hostDisplayCopy(locale, key, values = {}, recorded = false) {
    const language = hostDisplayLocale(locale);
    const template = recorded && key in recordedCopy[language]
        ? recordedCopy[language][key]
        : copy[language][key];
    return template.replace(/\{\{(\w+)\}\}/g, (_, name) => String(values[name] ?? ''));
}
//# sourceMappingURL=hostDisplayCopy.js.map